var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg001(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38.5,
    r: 38,
    fill: "#E7FFD8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_2516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5282 33.4968H27.8996C29.3296 33.4968 30.4996 34.6668 30.4996 36.0968V49.0966C30.4996 50.5266 29.3296 51.6966 27.8996 51.6966H27.5282C26.0982 51.6966 24.9282 50.5266 24.9282 49.0966V36.0968C24.9282 34.6668 26.0982 33.4968 27.5282 33.4968ZM37.9281 25.6969C39.358 25.6969 40.528 26.8669 40.528 28.2969V49.0966C40.528 50.5266 39.358 51.6966 37.9281 51.6966C36.4981 51.6966 35.3281 50.5266 35.3281 49.0966V28.2969C35.3281 26.8669 36.4981 25.6969 37.9281 25.6969ZM48.3279 40.5538C49.7579 40.5538 50.9279 41.7238 50.9279 43.1538V49.0966C50.9279 50.5266 49.7579 51.6966 48.3279 51.6966C46.8979 51.6966 45.7279 50.5266 45.7279 49.0966V43.1538C45.7279 41.7238 46.8979 40.5538 48.3279 40.5538Z",
    fill: "#46A46C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_2516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.5708,
    height: 44.5708,
    fill: "white",
    transform: "translate(15.6428 16.4113)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg001);
export default __webpack_public_path__ + "static/media/001.778cab0b9acc0ea0c82aea09cd2bdb7b.svg";
export { ForwardRef as ReactComponent };